import React, { useState, useRef, useEffect } from "react";
import "../css/FloatingButtons.css";

import hat from "../assets/santa-hat.png";
import Tree from "../assets/christmas-tree.avif";


const Float = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [position, setPosition] = useState({ top: 400, right: 25 });
  const [openDirection, setOpenDirection] = useState("right"); // Initialize with default direction
  const containerRef = useRef(null);

  const toggleButtons = () => {
    setIsOpen(!isOpen);
  };

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleMouseDown = (e) => {
    e.preventDefault();
    const element = containerRef.current;
    const startX = e.clientX;
    const startY = e.clientY;
    const initialRight = parseFloat(window.getComputedStyle(element).right);
    const initialTop = parseFloat(window.getComputedStyle(element).top);

    const handleMouseMove = (e) => {
      const newRight = initialRight - (e.clientX - startX);
      const newTop = initialTop + (e.clientY - startY);
      
      setPosition({
        top: newTop,
        right: newRight,
      });


      const screenWidth = window.innerWidth;
      const containerWidth = element.offsetWidth;
      setOpenDirection(newRight + containerWidth / 2 < screenWidth / 2 ? "right" : "left");
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };

  const handleTouchStart = (e) => {
    const touch = e.touches[0];
    const element = containerRef.current;
    const startX = touch.clientX;
    const startY = touch.clientY;
    const initialRight = parseFloat(window.getComputedStyle(element).right);
    const initialTop = parseFloat(window.getComputedStyle(element).top);

    const handleTouchMove = (e) => {
      const touch = e.touches[0];
      const newRight = initialRight - (touch.clientX - startX);
      const newTop = initialTop + (touch.clientY - startY);
      
      setPosition({
        top: newTop,
        right: newRight,
      });

      // Determine if the floating container is on the left or right side of the screen
      const screenWidth = window.innerWidth;
      const containerWidth = element.offsetWidth;
      setOpenDirection(newRight + containerWidth / 2 < screenWidth / 2 ? "right" : "left");
    };

    const handleTouchEnd = () => {
      document.removeEventListener("touchmove", handleTouchMove);
      document.removeEventListener("touchend", handleTouchEnd);
    };

    document.addEventListener("touchmove", handleTouchMove);
    document.addEventListener("touchend", handleTouchEnd);
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", (event) => {
        if (!containerRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      });
    }
  }, [isOpen]);

  return (
    <div
      className="floating-container"
      ref={containerRef}
      onMouseDown={handleMouseDown}
      onTouchStart={handleTouchStart}
      style={{ top: `${position.top}px`, right: `${position.right}px`, position: "fixed" }}
    >
      {/*  <img
                src={hat}
                alt="Profile"
                style={{     width: "60px",
                  position: "absolute",
                  zIndex: "100",
                  top: "-41px",
                  left: "4px",
                  pointerEvents: "none",
                }}
                
              />  */}

      <div className={"arrow-button"} onClick={() => window.location.href = "https://wa.me/ais/1882882965580580?s=5"} >
       
          {/*  <img className="w-10" src={Tree} alt="closed" /> */} 
          <div className="text-base"><span>Doc</span><span>Saab</span></div>
      </div>
     {/*  <div className={`floating-buttons ${isOpen ? "open" : ""} ${openDirection}`}>
      <button className="floating-btn">
    <a
      href="https://loginskip.com/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <i className="fa-solid fa-rocket" style={{ color: "#d8e2f3" }}></i>
    </a>
  </button>
        <button className="floating-btn">
          <Link
            to="/blog"
            onClick={(e) => {
              e.preventDefault();
              openInNewTab("/blog");
            }}
          >
            <i className="fa-solid fa-book-open-reader" style={{ color: "#d8e2f3" }}></i>
          </Link>
        </button>
        <button className="floating-btn">
          <Link
            to="/trending"
            onClick={(e) => {
              e.preventDefault();
              openInNewTab("/trending");
            }}
          >
            <i className="fa-solid fa-arrow-trend-up" style={{ color: "#d8e2f3" }}></i>
          </Link>
        </button>
      </div> */}
    </div>
  );
};

export default Float;
